import { isEmpty } from "lodash";
import React, { useContext, useEffect, useRef } from "react";
import { useState } from "react";
import BetSlipContext from "../../context/BetSlipContext";
import Keyboard from "./Keyboard";
import AuthContext from "../../context/AuthContext";
import secureLocalStorage from "react-secure-storage";

// --- Injected CSS for flash animation ---
const flashStyle = `
@keyframes flashYellow {
  0%   { background: #72e3a0; }
  20%  { background: #72bbef; }
  40%  { background: #f8e71c; }
  60%  { background: #f8e71c; }
  80%  { background: #72bbef; }
  100% { background: #72e3a0; }
}
.flash-yellow {
  animation: flashYellow 0.8s ease;
}
`;

// --- Sub-component to track odds changes and flash ---
const OddsCell = ({ res }) => {
  const prevOdds = useRef(res?.odds);
  const [flashing, setFlashing] = useState(false);

  useEffect(() => {
    if (prevOdds.current !== res?.odds) {
      prevOdds.current = res?.odds;
      setFlashing(true);
      const timer = setTimeout(() => setFlashing(false), 600);
      return () => clearTimeout(timer);
    }
  }, [res?.odds]);

  return (
    <p
      id="odds1"
      name={res?.odds}
      className={flashing ? "flash-yellow" : ""}
    >
      {Math.trunc(res.odds * 100) / 100}
    </p>
  );
};
const PreminumFancyNew = ({
  data,
  betType,
  setSlipObj,
  slipObj,
  details,
  profileData,
  user,
  resetSelection,
  key,
  messaageBox,
  setPremiumFancy,
  preminumFancyTab,
  activeSportBook,
  setActiveSportBook,
}) => {
  const [selected, setSelected] = useState("");
  const { parly, parlyBet, setParlyBet } = useContext(AuthContext);
  let { betSelectionObj, setBetSelectionObj, defaultStake, defaultOdds } =
    useContext(BetSlipContext);
  const [amountRange, setAmountRange] = useState({
    min: 0,
    max: 0,
    oddsLimit: 0,
    betDelay: 0,
  });

  // Local display data with suspend/remove logic
  const [displayData, setDisplayData] = useState(data);
  const suspensionTimersRef = useRef({});
  const prevDataRef = useRef(data);

  useEffect(() => {
    const prevIds = new Set(prevDataRef.current.map(item => item.id));
    const newIds = new Set(data.map(item => item.id));

    // Items that disappeared — suspend then remove after 5s
    prevDataRef.current.forEach(prevItem => {
      if (!newIds.has(prevItem.id) && !suspensionTimersRef.current[prevItem.id]) {
        // Mark suspended
        setDisplayData(current =>
          current.map(item =>
            item.id === prevItem.id
              ? {
                  ...item,
                  apiSiteStatus: "SUSPENDED",
                  markets: { ...item.markets, apiSiteStatus: "SUSPENDED" },
                  is_enable: false,
                }
              : item
          )
        );

        // Remove after 5 seconds
        suspensionTimersRef.current[prevItem.id] = setTimeout(() => {
          setDisplayData(current => current.filter(item => item.id !== prevItem.id));
          delete suspensionTimersRef.current[prevItem.id];
        }, 5000);
      }
    });

    // Items returning — cancel suspension timer
    data.forEach(newItem => {
      if (suspensionTimersRef.current[newItem.id]) {
        clearTimeout(suspensionTimersRef.current[newItem.id]);
        delete suspensionTimersRef.current[newItem.id];
      }
    });

    // Merge incoming fresh data with any currently suspended items
    setDisplayData(current => {
      const suspendedItems = current.filter(
        item => !newIds.has(item.id) && item.apiSiteStatus === "SUSPENDED"
      );
      return [...suspendedItems, ...data];
    });

    prevDataRef.current = data;
  }, [data]);

  // Cleanup all timers on unmount
  useEffect(() => {
    return () => {
      Object.values(suspensionTimersRef.current).forEach(clearTimeout);
    };
  }, []);

  useEffect(() => {
    if (!isEmpty(user)) {
      let obj = profileData?.matchSetting?.find(
        (res) =>
          res?.type == "sportBook" &&
          (profileData?.arrayCheck == "details"
            ? true
            : res?.sportType == details?.gameType),
      );
      if (!isEmpty(obj)) {
        setAmountRange({
          min: Number(obj?.minAmount) || 0,
          max: Number(obj?.maxAmount) || 0,
          oddsLimit: obj.oddsLimit ? obj.oddsLimit : 0,
          betDelay: obj?.betDelay,
        });
      }
    }
  }, [profileData, user, details]);

  const myRef = useRef(null);
  const [id, setId] = useState("");
  const [id2, setId2] = useState("");

  const handleScroll = () => {
    setId("");
    setId2("");
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (!isEmpty(id)) {
      myRef.current.scrollIntoView(true);
    }
  }, [id]);

  const [innerId, setInnerId] = useState("");

  useEffect(() => {
    if (key == "Fancy Bet") {
      setInnerId("");
      setSelected("");
    }
  }, [key]);

  useEffect(() => {
    if (selected && betSelectionObj?.betType == "premiumFancy") {
      const selectedItem = displayData?.find((item) => item?.id == selected);
      if (selectedItem) {
        const isSuspended =
          details?.sport_setting?.status == "inActive" ||
          selectedItem.marketStatus == 3 ||
          selectedItem.marketStatus == 2 ||
          selectedItem.marketStatus == 4 ||
          selectedItem.apiSiteStatus == "SUSPENDED";

        if (isSuspended) {
          resetSelection(betType);
          setSelected("");
          setInnerId("");
          setSlipObj({});
        }
      }
    }
  }, [displayData, details?.sport_setting?.status, selected, betSelectionObj?.betType]);

  useEffect(() => {
    setPremiumFancy((current) => {
      return current?.map((res, index) => {
        return { ...res, check: index < 5 ? true : false };
      });
    });
  }, []);

  useEffect(() => {
    if (details?.gameType == "cricket") {
      data.sort(function (a, b) {
        if (a.marketName === "Match Winner") return -1;
        if (a.marketName === "Will there be a tie") return 1;
        return 0;
      });
    }
  }, [details]);

  const [newActive, setNewActive] = useState([]);
  useEffect(() => {
    setNewActive(
      data?.slice(0, 50)?.map((po) => po?.id),
    );
  }, [data]);

  const sportBookCheck = (parlyBet, detail, res) => {
    if (isEmpty(user)) return "";
    let find = parlyBet?.find((res) => res?.newEventId == detail?.eventId);
    if (!isEmpty(find)) {
      return find?.sportsBookSelectionObject?.id == res?.id
        ? "active-sportBook rounded-b-md"
        : "rounded-b-md";
    } else {
      return "rounded-b-md";
    }
  };

  const allowedSoccerMarkets = [
    "Match Result",
    "Second Half Total Goals Over / Under 0.50",
    "Second Half Total Goals Over / Under 0.75",
    "Second Half Total Goals Over / Under 1.00",
    "Second Half Total Goals Over / Under 1.25",
    "Second Half Total Goals Over / Under 1.50",
    "Total Goals Over / Under 2.25",
    "Second Half Draw No Bet",
    "Odd Or Even Goals",
    "No Draw Both Teams To Score - Yes/No",
    "Total Goals Over / Under 1.25",
    "Total Goals Over / Under 1.50",
    "Total Goals Over / Under 2.50",
    "Draw No Bet",
    "Total Goals Over / Under 2.75",
    "Half Time Result",
    "Second Half Match Result",
    "Half Time First Team To Score",
    "Exact Number of Goals",
    "Odd Or Even Total",
    "Both Teams To Score 2 or More Goals",
    "Correct Score",
  ];

  const filteredData =
    details?.gameType === "soccer"
      ? displayData
          ?.filter((item) => allowedSoccerMarkets.includes(item?.marketName))
          ?.sort(
            (a, b) =>
              allowedSoccerMarkets.indexOf(a?.marketName) -
              allowedSoccerMarkets.indexOf(b?.marketName),
          )
      : displayData?.sort((a, b) => {
          const topMarkets = ["Match Winner", "Match Result"];
          const aIsTop = topMarkets.includes(a?.marketName);
          const bIsTop = topMarkets.includes(b?.marketName);
          if (aIsTop && !bIsTop) return -1;
          if (!aIsTop && bIsTop) return 1;
          return 0;
        });

  return filteredData?.length > 0 ? (
    <>
      <style>{flashStyle}</style>
      <div
        id="fancyBetTabWrap"
        className="special_bets-tab-wrap ps ps--theme_default ps--active-x"
      >
        <ul className="special_bets-tab" style={{ overflowX: "scroll" }}>
          {preminumFancyTab?.length > 0 &&
            preminumFancyTab?.map((res) => (
              <li>
                <a href="javascript:void(0)">{res.name}</a>
              </li>
            ))}
        </ul>
      </div>

      {filteredData?.map((item, index) => {
        if (item?.sportsBookSelection?.length > 0 && details?.gameType) {
          return (
            <div
              id="sportsBookMarket_2_2558118_265869284"
              className="bets-wrap sports-book new-premimum-fancy"
              key={index + 1}
            >
              <h4
                ref={item?.id == id ? myRef : null}
                onClick={() => {
                  setSelected(item?.id);
                  setActiveSportBook((current) => {
                    if (newActive?.includes(item?.id)) {
                      setNewActive((prev) =>
                        prev?.filter((res) => res !== item?.id)
                      );
                    } else {
                      if (current?.includes(item?.id)) {
                        return current?.filter((res) => res !== item?.id);
                      } else {
                        return current?.length > 0
                          ? [...current, item?.id]
                          : [item?.id];
                      }
                    }
                  });
                }}
                style={{ marginBottom: "0" }}
              >
                <span id="marketName" className="to-collapse">
                  {item?.marketName}
                </span>
                <div className="fancy_info-popup">
                  <dl>
                    <dt>Min / Max</dt>
                    <dd>
                      {amountRange?.min?.toFixed(2)} /{" "}
                      {amountRange?.max?.toFixed(2)}
                    </dd>
                  </dl>
                  <a className="close">Close</a>
                </div>
              </h4>

              <div className="text-dark daka-score-sec">
                {[
                  ...newActive,
                  ...(activeSportBook?.length > 0 ? activeSportBook : []),
                ]?.includes(item?.id) &&
                  item?.sportsBookSelection
                    ?.filter((res) => res?.isActive === 1)
                    ?.map((res) => {
                      let newPosition = "";
                      if (
                        betSelectionObj?.priceToogle &&
                        betSelectionObj?.betType == "premiumFancy" &&
                        innerId == slipObj?.selectId &&
                        item?.id == selected
                      ) {
                        let backProfit =
                          (Number(betSelectionObj?.oddsSelect) - 1) *
                          Number(betSelectionObj?.bidPrice);
                        let backLoss = Number(betSelectionObj?.bidPrice);
                        if (res.id === slipObj?.selectId) {
                          newPosition =
                            Math.abs(res?.position) > 0
                              ? Number(backProfit) + Number(res.position)
                              : Number(backProfit);
                        } else {
                          newPosition =
                            Math.abs(res?.position) > 0
                              ? Number(backLoss) - Number(res?.position)
                              : -Number(backLoss);
                        }
                      }

                      let condition =
                        betSelectionObj?.priceToogle &&
                        betSelectionObj?.betType == "premiumFancy" &&
                        innerId == slipObj?.selectId &&
                        item?.id == selected &&
                        Number(betSelectionObj?.bidPrice) > 0;

                      const isSuspended =
                        details?.sport_setting?.status == "inActive" ||
                        item.marketStatus == 3 ||
                        item.marketStatus == 2 ||
                        item.marketStatus == 4 ||
                        item.apiSiteStatus == "SUSPENDED";

                      return (
                        <>
                          <div
                            style={{
                              backgroundColor: import.meta.env
                                .VITE_PREMIUM_FANCY_BOX_COLOR
                                ? import.meta.env.VITE_PREMIUM_FANCY_BOX_COLOR
                                : "",
                            }}
                            className={
                              isSuspended
                                ? "rounded-b-md suspended"
                                : parly
                                  ? sportBookCheck(parlyBet, details, res)
                                  : slipObj.selectId == res.id
                                    ? `back-active rounded-b-md ${
                                        Number(
                                          document.getElementById("odds1")?.name,
                                        ) !== res?.odds && "fade-in-out"
                                      }`
                                    : `rounded-b-md ${
                                        Number(
                                          document.getElementById("odds1")?.name,
                                        ) !== res?.odds && "fade-in-out"
                                      }`
                            }
                            onClick={() => {
                              if (isSuspended) return;
                              if (
                                item.marketStatus !== "1" &&
                                item.marketStatus !== "0"
                              ) return;

                              if (details?.sport_setting?.status == "active") {
                                if (details.premiumFancy == "on") {
                                  if (parly) {
                                    setParlyBet((current) => {
                                      let newObj = {
                                        ...item,
                                        sportsBookSelectionObject: res,
                                        selectObj: res?.id,
                                        newEventId: details?.eventId,
                                        eventName: details?.eventName,
                                        marketId: details?.marketId,
                                      };
                                      if (current?.length > 0) {
                                        if (
                                          current?.filter(
                                            (temp) => temp?.newEventId == details?.eventId
                                          )?.length > 0
                                        ) {
                                          if (
                                            current?.filter(
                                              (temp) => temp?.newEventId !== details?.eventId
                                            )?.length > 0
                                          ) {
                                            secureLocalStorage.setItem("parlyBet", [
                                              ...current?.filter(
                                                (temp) => temp?.newEventId !== details?.eventId
                                              ),
                                              newObj,
                                            ]);
                                            return [
                                              ...current?.filter(
                                                (temp) => temp?.newEventId !== details?.eventId
                                              ),
                                              newObj,
                                            ];
                                          } else {
                                            secureLocalStorage.setItem("parlyBet", [newObj]);
                                            return [newObj];
                                          }
                                        } else {
                                          secureLocalStorage.setItem("parlyBet", [...current, newObj]);
                                          return [...current, newObj];
                                        }
                                      } else {
                                        secureLocalStorage.setItem("parlyBet", [newObj]);
                                        return [newObj];
                                      }
                                    });
                                  } else {
                                    if (!messaageBox) {
                                      if (betSelectionObj.betType !== betType) {
                                        resetSelection(betSelectionObj.betType);
                                      }
                                      setSelected(item?.id);
                                      setBetSelectionObj((prev) => ({
                                        ...betSelectionObj,
                                        betType: betType,
                                        oddsSelect: res?.odds,
                                        bidPrice: defaultStake == 0 ? "" : defaultStake,
                                        priceToogle: true,
                                        layorback: "back",
                                        inputType: "price",
                                        expectany: defaultOdds,
                                        minAmount: amountRange.min,
                                        maxAmount: amountRange.max,
                                      }));
                                      setId(item?.id);
                                      setInnerId(res?.id);
                                      setSlipObj({
                                        ...item,
                                        selectId: res.id,
                                        newMarketId: item.id,
                                        obj: res,
                                      });
                                    }
                                  }
                                }
                              }
                            }}
                          >
                            {details?.sport_setting?.status == "inActive" ||
                            item.marketStatus == 3 ||
                            item.apiSiteStatus == "SUSPENDED" ? (
                              <div className="suspend-case">
                                <strong>Suspended</strong>
                              </div>
                            ) : item?.marketStatus == 1 ? (
                              ""
                            ) : (
                              <div className="suspend-case">
                                <strong>
                                  {item?.marketStatus == 9
                                    ? "Ball Running"
                                    : item?.marketStatus == 2
                                      ? "Suspended"
                                      : item?.marketStatus == 3
                                        ? "Suspended"
                                        : item?.marketStatus == 4
                                          ? "Closed"
                                          : ""}
                                </strong>
                              </div>
                            )}

                            <h5>{res.selectionName}</h5>
                            <div style={{ display: "flex" }}>
                              {(Math.abs(res.position) > 0 || condition) && (
                                <div
                                  className="dolor_tag"
                                  style={{
                                    color:
                                      (res?.position || newPosition) >= 0
                                        ? "green"
                                        : "red",
                                  }}
                                >
                                  {Math.abs(res.position) > 0 &&
                                    Math.abs(res?.position)?.toFixed(2)}
                                  {!parly &&
                                    condition &&
                                    Math.abs(newPosition) > 0 &&
                                    betSelectionObj?.priceToogle &&
                                    betSelectionObj?.betType == betType && (
                                      <>
                                        <span className="right-arrow">
                                          <img
                                            src={
                                              import.meta.env.VITE_IMAGE_URL +
                                              "/assets/images/down-arrow.png"
                                            }
                                            alt=""
                                          />
                                        </span>
                                        $({Math.abs(newPosition)?.toFixed(2)})
                                      </>
                                    )}
                                </div>
                              )}
                              <OddsCell res={res} />
                            </div>
                          </div>
                        </>
                      );
                    })}
              </div>

              {betSelectionObj?.priceToogle &&
                betSelectionObj?.betType == "premiumFancy" &&
                innerId == slipObj?.selectId &&
                item?.id == selected && (
                  <Keyboard
                    setSlipObj={setSlipObj}
                    details={details}
                    slipObj={slipObj}
                    amountRange={amountRange}
                    betType={betType}
                    resetSelection={resetSelection}
                  />
                )}
            </div>
          );
        }
      })}
    </>
  ) : (
    <div
      id="sportsBookNoBet"
      className="bets-wrap"
      style={{ display: "block" }}
    >
      <p className="no-game">Sports Book has no market</p>
    </div>
  );
};

export default PreminumFancyNew;